const PREFIX = 'LOCALSTORAGE';
export const LOCAL_STORAGE_SET_ITEM = `${PREFIX}:SET_ITEM`;
export const LOCAL_STORAGE_SET_ITEM_COMPLETED = `${PREFIX}:SET_ITEM_COMPLETED`;
export const LOCAL_STORAGE_CLEAR_ALL = `${PREFIX}:CLEAR_ALL`;
